var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { defaultTheme, extendTheme as coreExtendTheme, colorSchemes, generatedColorScheme, } from '@stardust-ds/core';
import merge from 'lodash.merge';
import { createContext, useContext, useMemo } from 'react';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle } from './global';
import { webTheme } from './theme';
var buildCustomTheme = function (customDevTheme) {
    if (customDevTheme === void 0) { customDevTheme = {}; }
    return coreExtendTheme(__assign(__assign({}, webTheme), customDevTheme));
};
var INITIAL_THEME_CONTEXT = {
    theme: buildCustomTheme(),
};
var ThemeContext = createContext(INITIAL_THEME_CONTEXT);
export default function StardustThemeProvider(_a) {
    var children = _a.children, theme = _a.theme;
    var valueProvider = useMemo(function () { return ({
        theme: buildCustomTheme(theme),
    }); }, [theme]);
    return (_jsx(ThemeContext.Provider, __assign({ value: valueProvider }, { children: _jsx(ThemeProvider, __assign({ theme: valueProvider.theme }, { children: _jsxs(_Fragment, { children: [children, _jsx(GlobalStyle, {})] }) })) })));
}
export var useThemeContext = function () { return useContext(ThemeContext); };
export function useTheme() {
    return useThemeContext().theme;
}
export function extendTheme(devTheme) {
    return merge(merge(defaultTheme, { brand: webTheme }), {
        brand: devTheme,
    });
}
// @ts-ignore
export var customTheme = buildCustomTheme();
export { colorSchemes, generatedColorScheme };
